import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, FormArray, AbstractControl, ValidationErrors } from '@angular/forms';
import { ZoningCode } from 'src/app/modules/instance/models';
import { ProcessService, ZoningCodeService } from 'src/app/modules/instance/services';
import { CalculationErrorStatuses } from 'src/app/shared';
import * as _ from 'lodash';

@Component({
    standalone: false,
    selector: 'app-recalculate-by-status',
    templateUrl: './recalculate-by-status.component.html',
    styleUrls: ['./recalculate-by-status.component.scss']
})
export class RecalculateByStatusComponent implements OnInit {
    @Output()
    formReady = new EventEmitter<FormGroup>();

    recalculateForm: FormGroup;
    statusesToRecalculate: any;
    zoningCodes: Array<ZoningCode>;

    constructor(
        private formBuilder: FormBuilder,
        private readonly zoningCodeService: ZoningCodeService,
        readonly processService: ProcessService
    ) {}

    get maxThreadsCount() {
        return _.get(this, 'recalculateForm.value.maxThreadsCount', 0);
    }

    static getQueryParams(formGroup: any): any {
        return {
            statusesToRecalculate: formGroup['statusesToRecalculate'],
            zoningCodeId: formGroup['zoningCode'] && formGroup['zoningCode'].Id,
            maxThreadsCount: formGroup['maxThreadsCount']
        };
    }

    getCalculationErrorStatusByType(type) {
        return CalculationErrorStatuses[type];
    }

    get CalculationErrorStatus() {
        return CalculationErrorStatuses.keys();
    }

    checkboxIsValid(_c?: AbstractControl): ValidationErrors {
        return _.get(this.statusesToRecalculate, 'length') ? null : { checkbox: true };
    }

    onChange(event) {
        this.statusesToRecalculate = (<FormArray>this.recalculateForm.get('statusesToRecalculate')) as FormArray;

        if (event.checked) {
            this.statusesToRecalculate.push(new FormControl(event.source.value));
        } else {
            const i = this.statusesToRecalculate.controls.findIndex(x => x.value === event.source.value);
            this.statusesToRecalculate.removeAt(i);
        }
        this.recalculateForm.controls['checkbox'].setErrors(this.checkboxIsValid());
    }

    ngOnInit() {
        this.zoningCodes = this.zoningCodeService.lastZoningCodesValue;

        this.recalculateForm = this.formBuilder.group({
            statusesToRecalculate: this.formBuilder.array([]),
            zoningCode: '',
            checkbox: ['', this.checkboxIsValid],
            maxThreadsCount: new FormControl(1)
        });
        this.formReady.emit(this.recalculateForm);
    }

    safeValue(value: number | null) {
        if (!value) {
            return 0;
        }

        return value;
    }
}
